import PropTypes from 'prop-types';
import React, {useEffect, useState} from 'react';
import Dialog from '@mui/material/Dialog';
import {BrickContext} from 'olympe';
import {FillInInfoContent} from './search_supplier_components/FillInInfoContent.jsx';
import {DefineSupplierContent} from './search_supplier_components/DefineSupplierContent.jsx';
import {requestStores} from '../../ListOfPREditors.brick.jsx';

/**
 *
 * @param {DefineSupplierPopup.propTypes} props
 * @return {JSX.Element}
 */
export function DefineSupplierPopup(props) {
    const useRequestStore = requestStores.get(props.prTag);
    const companyCode = useRequestStore((state) => state.companyCode);
    const purchaseOrganization = useRequestStore((state) => state.purchaseOrganization);

    const [showFillInInfo, setShowFillInInfo] = useState(!companyCode.value || !purchaseOrganization.value);

    // Each time that we open the popup, check if the company code and purchase org are defined.
    useEffect(() => {
        setShowFillInInfo(!companyCode.value || !purchaseOrganization.value);
    }, [props.open]);

    const handleCancel = () => {
        props.onCancel();
    };

    return (
        <Dialog open={props.open} onClose={handleCancel} fullWidth maxWidth={'lg'} PaperProps={{
            sx: {
                borderRadius: '10px',
            },
        }}>
            {showFillInInfo ? <FillInInfoContent context={props.context} onCancel={handleCancel} onClose={() => setShowFillInInfo(false)} prTag={props.prTag}/> :
                <DefineSupplierContent context={props.context} onCancel={handleCancel} onClose={props.onClose} prTag={props.prTag} prLocked={props.prLocked} onClosePunchOut={props.onClosePunchOut}/>
            }
        </Dialog>
    );
}

DefineSupplierPopup.propTypes = {
    onClose: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    context: PropTypes.instanceOf(BrickContext).isRequired,
    prTag: PropTypes.string,
    prLocked: PropTypes.bool,
    onClosePunchOut: PropTypes.func,
};
